enum ThreeDPPages {
  education = 0,
  quiz,
  results,
}

export default ThreeDPPages;
